<template>
	<div
		class="w-[34px] h-[34px] rounded-full flex justify-center items-center"
		:style="`background-color: ${badgeBg}`"
	>
		<Component :is="iconComponent" :size="20" color="#000" />
	</div>
</template>

<script>
import { getTraitIcon, traitColors } from '~/components/Icons/traits'

export default {
	name: 'TraitBadge',
	props: {
		trait: {
			type: String,
			required: true
		}
	},
	computed: {
		iconComponent() {
			return getTraitIcon(this.trait)
		},
		badgeBg() {
			return traitColors[this.trait] || '#FFFFFF'
		}
	}
}
</script>
